<template>
  <b-form-group
    label="CPF"
    label-for="cpf"
    description="Digite o CPF no formato XXX.XXX.XXX-XX"
  >
    <b-form-input
      id="cpf"
      v-model="formattedCpf"
      type="text"
      placeholder="XXX.XXX.XXX-XX"
      required
      :state="cpfState"
      aria-describedby="cpf-feedback"
      @blur="validateCpf"
      :maxlength="14"
    />
    <b-form-invalid-feedback id="cpf-feedback">
      Por favor, insira um CPF válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'CpfInput',
  props: {
    value: {
      type: String,
      required: true,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      cpfState: this.state,
    };
  },
  computed: {
    formattedCpf: {
      get() {
        return this.formatCpf(this.value);
      },
      set(newValue) {
        const cleaned = this.cleanCpf(newValue).slice(0, 11);
        this.$emit('input', cleaned);
      },
    },
  },
  watch: {
    state(newValue) {
      this.cpfState = newValue;
    },
  },
  mounted() {
    if (this.value) {
      this.validateCpf();
    }
  },
  methods: {
    formatCpf(value) {
      const cleaned = (value || '').replace(/\D/g, '');
      if (cleaned.length > 11) {
        return cleaned
          .slice(0, 11)
          .replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*$/, '$1.$2.$3-$4');
      }
      return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    },
    cleanCpf(value) {
      return (value || '').replace(/\D/g, '');
    },
    validateCpf() {
      const cleaned = this.cleanCpf(this.value);
      if (cleaned.length !== 11 || !this.isValidCpf(cleaned)) {
        this.cpfState = false;
      } else {
        this.cpfState = true;
      }
      this.$emit('validation-updated', this.cpfState);
    },
    isValidCpf(cpf) {
      if (/^(\d)\1+$/.test(cpf)) return false;
      let sum = 0;
      let remainder;

      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
      }
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(9, 10), 10)) {
        return false;
      }

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
      }
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(10, 11), 10)) {
        return false;
      }
      return true;
    },
  },
};
</script>
